import { Text } from "@overmap-ai/blocks"
import { type ProjectAttachment, type Stored } from "@overmap-ai/common"
import { selectUserById } from "@overmap-ai/core"
import { memo } from "react"

import { ProjectTimelineItemType } from "../../enums/projects"
import { useAppSelector } from "../../store"
import { formatCompactDate } from "../../utils/date"
import { getUserDisplayLabel } from "../../utils/users"
import { ProjectTimelineCard } from "./ProjectTimelineCard"
import { getTimelineDate } from "./utils"

interface ProjectTimelineProjectAttachmentItemProps {
	projectAttachment: Stored<ProjectAttachment>
}

export const ProjectTimelineProjectAttachmentItem = memo<ProjectTimelineProjectAttachmentItemProps>((props) => {
	const { projectAttachment } = props

	const user = useAppSelector(selectUserById(projectAttachment.created_by ?? -1))

	return (
		<ProjectTimelineCard type={ProjectTimelineItemType.PROJECT_ATTACHMENT}>
			<Text size="sm" accentColor="base" className="min-w-0">
				<Text highContrast>{getUserDisplayLabel(user)}</Text>
				&nbsp;attached a file to project&nbsp;
				<Text highContrast>{projectAttachment.file_name}</Text>
				<Text accentColor="base">
					&nbsp;&#8226;&nbsp;{formatCompactDate(getTimelineDate(projectAttachment))}
				</Text>
			</Text>
		</ProjectTimelineCard>
	)
})
ProjectTimelineProjectAttachmentItem.displayName = "ProjectTimelineProjectAttachmentItem"
